// extracted by mini-css-extract-plugin
module.exports = {"tooltip3D":"styles_tooltip3D__IpAbx","tooltip":"styles_tooltip__G20WB","textContent":"styles_textContent__UHOea","title":"styles_title__VmTkx","text":"styles_text__tpDb1"};